import { Col, message, PageHeader, Row, Spin, Select, Space, Tabs } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { SelectItem, Form, FormItem, cuentaMask, RangePickerItem, TableItem, ButtonItem, ErrorItem } from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import * as XLSXStyle from "xlsx-js-style";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteComodatos extends Component {
  state = {
    loading: false,
    objetoProveedores: null,
    objetoClientes: null,
    objetoProyectos: null,
    objetoUniadesDeNegocio: null,
    dataReporte: null,
    todosInsumos: [],
    cantidad: 0,
  };

  atras() { this.props.history.goBack(); }

  async componentDidMount() {
    this.setState({ loading: true });

    await Promise.all([
      axios.post("proveedores/selectProveedores", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoProveedores: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.stringBuscar}</Option>
            )),
          });
        }
      }),
      axios.post("proyectos/selectProyectos", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre}</Option>
            )),
          });
        }
      }),
      axios.post("clientes/selectClientes", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoClientes: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.stringBuscar}</Option>
            )),
          });
        }
      }),
      axios.post("unidadesdenegocio/selectUnidadesDeNegocio", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + " - " + value.nombre}
              </Option>
            )),
          });
        }
      })
    ]);

    this.consultarReporteComodatos({
      periodo: [moment().subtract(1, "month"), moment()],
      proveedores: 0,
      clientes: 0,
      filtrarProyecto: 0,
      estado: 5,
    });
  }

  consultarReporteComodatos(values) {
    this.setState({ loading: true });
    axios.post("reportesDeCompras/reporteComodatos",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
    ).then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            dataReporte: res.data,
            todosInsumos: res.data.insumos,
            cantidad: res.data.totales.cantidad,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      }).catch(() => {
          message.error("Error de conexión");
          this.setState({ loading: false });
      });
  }

  estiloExcel() {
    const border = {
      top: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
    };
    const headerStyle = {
      font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "00BFD6" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border,
    };
    const cellStyle = { alignment: { vertical: "center" }, border };
    const numeroStyle = { alignment: { horizontal: "right", vertical: "center" }, border };
    const celda = (value, tipo) => {
      if (tipo === "numero") {
        return { v: typeof value === "number" ? value : 0, s: numeroStyle };
      }
      return { v: value === null || value === undefined ? "" : value, s: cellStyle };
    };
    return { headerStyle, celda };
  }

  generarHojaEstilizada(columnasConfig, datos) {
    const { headerStyle, celda } = this.estiloExcel();
    const rows = [
      columnasConfig.map((columna) => ({ v: columna.header, s: headerStyle })),
      ...datos.map((fila) => columnasConfig.map((columna) => celda(fila[columna.key], columna.tipo))),
    ];
    const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
    worksheet["!cols"] = columnasConfig.map((columna) => ({ wch: Math.max(columna.header.length + 2, 12) }));
    return worksheet;
  }

  descargarExcelAcumulado() {
    const columnasConfig = [
      { header: "Clave", key: "Clave", tipo: "texto" },
      { header: "Código Barras", key: "Código Barras", tipo: "texto" },
      { header: "Descripción", key: "Descripción", tipo: "texto" },
      { header: "Familia", key: "Familia", tipo: "texto" },
      { header: "Última Recepción", key: "Última Recepción", tipo: "texto" },
      { header: "Cantidad", key: "Cantidad", tipo: "numero" },
    ];

    const datos = this.state.todosInsumos.map((item) => ({
      "Clave": item.clave,
      "Código Barras": item.codigoBarras,
      "Descripción": item.descripcion,
      "Familia": item.familia || 'N/A',
      "Última Recepción": item.fechaUltimaRecepcion ? moment(item.fechaUltimaRecepcion).format("DD/MM/YYYY") : "",
      "Cantidad": item.cantidad,
    }));

    const worksheet = this.generarHojaEstilizada(columnasConfig, datos);
    const workbook = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Comodatos por Insumo");
    XLSXStyle.writeFile(workbook, `Comodatos_Acumulado_${moment().locale("es").format("L")}.xlsx`);
  }

  descargarExcelDesglosado() {
    const grupos = new Map();
    this.state.todosInsumos.forEach((item) => {
      (item.historial || []).forEach((lote) => {
        const fecha = lote.fechaRecepcion || lote.fechaOrden;
        const fechaStr = fecha ? moment(fecha).format("DD/MM/YYYY") : "";
        const key = `${item.clave}||${lote.tipoEntidad}||${lote.entidad}||${fechaStr}`;
        if (!grupos.has(key)) {
          grupos.set(key, {
            "Clave": item.clave,
            "Descripción": item.descripcion,
            "Tipo": lote.tipoEntidad,
            "Entidad": lote.entidad,
            "Fecha Recepción": fechaStr,
            "Cantidad": 0,
          });
        }
        grupos.get(key)["Cantidad"] += Number(lote.cantidad) || 0;
      });
    });

    const columnasConfig = [
      { header: "Clave", key: "Clave", tipo: "texto" },
      { header: "Descripción", key: "Descripción", tipo: "texto" },
      { header: "Tipo", key: "Tipo", tipo: "texto" },
      { header: "Entidad", key: "Entidad", tipo: "texto" },
      { header: "Fecha Recepción", key: "Fecha Recepción", tipo: "texto" },
      { header: "Cantidad", key: "Cantidad", tipo: "numero" },
    ];

    const worksheet = this.generarHojaEstilizada(columnasConfig, Array.from(grupos.values()));
    const workbook = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Desglosado por Entidad");
    XLSXStyle.writeFile(workbook, `Comodatos_Desglosado_${moment().locale("es").format("L")}.xlsx`);
  }

  onFinishFailed(e) { ErrorItem(e); }

  render() {
    let columns = [
      { title: "Clave", dataIndex: "clave", key: "clave", buscar: "clave", width: "10%" },
      { title: "Código Barras", dataIndex: "codigoBarras", key: "codigoBarras", buscar: "codigoBarras", width: "12%" },
      { title: "Descripción", dataIndex: "descripcion", key: "descripcion", buscar: "descripcion", width: "42%", ellipsis: true },
      { title: "Familia", dataIndex: "familia", key: "familia", buscar: "familia", width: "18%" },
      { title: "Última Recepción", dataIndex: "fechaUltimaRecepcion", key: "fechaUltimaRecepcion", width: "10%", render: (v) => (v ? moment(v).format("DD/MM/YYYY") : "") },
      { title: "Cantidad", dataIndex: "cantidad", key: "cantidad", sorter: (a, b) => a.cantidad - b.cantidad, align: "right", width: "8%" },
    ];

    let columnsHistorial = [
      { title: "Folio Comodato", dataIndex: "folio", key: "folio", width: "11%" },
      { title: "Tipo", dataIndex: "tipoEntidad", key: "tipoEntidad", width: "9%" },
      { title: "Entidad", dataIndex: "entidad", key: "entidad", width: "18%", ellipsis: true },
      { title: "Fecha Comodato", dataIndex: "fechaOrden", key: "fechaOrden", width: "11%", render: (v) => (v ? moment(v).format("DD/MM/YYYY") : "") },
      { title: "Fecha Recepción", dataIndex: "fechaRecepcion", key: "fechaRecepcion", width: "11%", render: (v) => (v ? moment(v).format("DD/MM/YYYY") : "") },
      { title: "Lote", dataIndex: "lote", key: "lote", width: "13%" },
      { title: "Número", dataIndex: "numeroLote", key: "numeroLote", width: "9%" },
      { title: "Caducidad", dataIndex: "caducidad", key: "caducidad", width: "9%", render: (v) => (v ? moment(v).format("DD/MM/YYYY") : "") },
      { title: "Cantidad", dataIndex: "cantidad", key: "cantidad", width: "9%", align: "right" },
    ];

    const expandedRowRender = (record) => {
      if (!record.historial || record.historial.length === 0) {
        return <p style={{ margin: "8px 0", color: "#aaa", textAlign: "center" }}>Sin lotes registrados para este insumo</p>;
      }
      return (
        <TableItem
          columns={columnsHistorial}
          dataSource={record.historial}
          size="small"
          pagination={false}
          rowKey={(r, i) => `historial-${i}`}
        />
      );
    };

    return (
      <>
        <Form ref={this.formRef} name="reporteComodatos" onFinish={this.consultarReporteComodatos.bind(this)} onFinishFailed={this.onFinishFailed} initialValues={{ periodo: [moment().subtract(1, "month"), moment()] }}>
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte de Comodatos"
            style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && <ButtonItem blanco onClick={() => this.descargarExcelAcumulado()} icon={<FileExcelOutlined />}>Descargar Excel Acumulado</ButtonItem>}
                  {this.state.dataReporte && <ButtonItem blanco onClick={() => this.descargarExcelDesglosado()} icon={<FileExcelOutlined />}>Descargar Excel Desglosado</ButtonItem>}
                  <ButtonItem type="primary" htmlType="submit">Consultar</ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            {/* FILTROS */}
            <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5, borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
              <Tabs style={{ margin: 0 }} tabBarExtraContent={{ left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1> }}>
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle><RangePickerItem /></FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Proveedores">
                  <FormItem name="proveedores" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Proveedores">{this.state.objetoProveedores}</SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Clientes">{this.state.objetoClientes}</SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem name="filtrarProyecto" required noStyle initialValue={0}>
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>Ninguno</Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto = getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) return (<FormItem required name="proyectos" margin noStyle><SelectItem width="90%" placeholder="Proyectos" mode="multiple">{this.state.objetoProyectos}</SelectItem></FormItem>);
                          if (filtrarProyecto === 2) return (<FormItem required margin name="unidadDeNegocioId" noStyle><SelectItem width="90%" placeholder="Unidades de Negocio">{this.state.objetoUniadesDeNegocio}</SelectItem></FormItem>);
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Opciones">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    <Col span={8}>
                      <FormItem label="Estado del Comodato" name="estado" required initialValue={5} style={{ marginBottom: 0 }}>
                        <SelectItem placeholder="Filtrar Por">
                          <Option default value={5}>Activos</Option>
                          <Option value={1}>Cancelados</Option>
                          <Option value={0}>Todos</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>

            {/* TOTALES */}
            <div style={{ backgroundColor: "white", padding: 15, marginTop: 10, marginBottom: 10, height: "75px", borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
              <Row justify="center">
                <Col span={8} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total Cantidad</p>
                  <h1 style={{ fontSize: 18 }}>{Number(this.state.cantidad).toFixed(this.props.decimalesEmpresa || 2)}</h1>
                </Col>
              </Row>
            </div>

            <TableItem
              rowKey={(value) => value._id.toString()}
              columns={columns}
              dataSource={this.state.todosInsumos}
              size="small"
              pagination={false}
              expandable={{
                expandedRowRender,
                rowExpandable: (r) => r.historial && r.historial.length > 0,
              }}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken, empresaId: state.empresa.id, decimalesEmpresa: state.empresa.decimalesEmpresa });
export default connect(mapStateToProps)(ReporteComodatos);
